import Vue from 'vue'
import Router from 'vue-router'
import * as Vuex from 'vuex'
import store from '@/store'
import LandingPage from '@/pages/LandingPage.vue'
import Splash from '@/pages/Splash.vue'
import SignIn from '@/pages/SignIn.vue'
import PasswordReset from '@/pages/PasswordReset.vue'
import PasswordRegistration from '@/pages/registration/PasswordRegistration.vue'
import PasswordComplete from '@/pages/registration/PasswordComplete.vue'
import Registration from '@/pages/registration/Registration.vue'
import CreateProfile from '@/pages/registration/CreateProfile.vue'
import CompleteProfile from '@/pages/registration/CompleteProfile.vue'
import LoggedInHome from '@/pages/LoggedInHome.vue'
import BenefitsList from '@/pages/BenefitsList.vue'
import NewsList from '@/pages/news/NewsList.vue'
import NewsDetail from '@/pages/news/NewsDetail.vue'
import TradeItem from '@/pages/TradeItem.vue'
import ItemList from '@/pages/items/ItemList.vue'
import ItemDetail from '@/pages/items/ItemDetail.vue'
import ItemUse from '@/pages/items/ItemUse.vue'
import HistoryPoint from '@/pages/HistoryPoint.vue'
import CaptureStamp from '@/pages/CaptureStamp.vue'
import FAQ from '@/pages/FAQ.vue'
import CheckIn from '@/pages/checkin/CheckIn.vue'
import CheckInComplete from '@/pages/checkin/CheckInComplete.vue'
import Settings from '@/pages/settings/Settings.vue'
import SettingsProfile from '@/pages/settings/SettingsProfile.vue'
import SettingsMail from '@/pages/settings/SettingsMail.vue'
import SettingsPassword from '@/pages/settings/SettingsPassword.vue'
import SettingsTwitterAuth from '@/pages/settings/SettingsTwitterAuth.vue'
import Company from '@/pages/about/Company.vue'
import Terms from '@/pages/about/Terms.vue'
import Policies from '@/pages/about/Policies.vue'
import Share from '@/pages/about/Share.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/top',
      name: 'top',
      component: Splash,
      meta: { isPublic: true }
    },
    {
      path: '/signin',
      name: 'signin',
      component: SignIn,
      meta: { isPublic: true }
    },
    {
      path: '/password/reset',
      name: 'password_reset',
      component: PasswordReset,
      meta: { isPublic: true }
    },
    {
      path: '/registration',
      name: 'registration',
      component: Registration,
      meta: { isPublic: true }
    },
    {
      path: '/registration/password',
      name: 'registration_password',
      component: PasswordRegistration,
      meta: { isPublic: true }
    },
    {
      path: '/registration/password/complete',
      name: 'registration_password_complete',
      component: PasswordComplete,
      meta: { isPublic: true }
    },
    {
      path: '/registration/profile',
      name: 'registration_profile',
      component: CreateProfile,
      meta: { isPublic: true }
    },
    {
      path: '/registration/profile/complete',
      name: 'registration_profile_complete',
      component: CompleteProfile,
      meta: { isPublic: true }
    },
    {
      path: '/home',
      name: 'home',
      component: LoggedInHome
    },
    {
      path: '/benefits',
      name: 'benefits',
      component: BenefitsList
    },
    {
      path: '/news',
      name: 'news',
      component: NewsList
    },
    {
      path: '/news/:id',
      name: 'news_id',
      component: NewsDetail
    },
    {
      path: '/trade/:id',
      name: 'trade_id',
      component: TradeItem
    },
    {
      path: '/items',
      name: 'items',
      component: ItemList
    },
    {
      path: '/items/:id',
      name: 'items_id',
      component: ItemDetail
    },
    {
      path: '/items/:id/use',
      name: 'items_id_use',
      component: ItemUse
    },
    {
      path: '/history',
      name: 'history',
      component: HistoryPoint
    },
    {
      path: '/capture/:id',
      name: 'capture',
      component: CaptureStamp,
      meta: { isPublic: true }
    },
    {
      path: '/faq',
      name: 'faq',
      component: FAQ
    },
    {
      path: '/checkin',
      name: 'checkin',
      component: CheckIn
    },
    {
      path: '/checkin/complete',
      name: 'checkin_complete',
      component: CheckInComplete
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/settings/profile',
      name: 'settings_profile',
      component: SettingsProfile
    },
    {
      path: '/settings/email',
      name: 'settings_email',
      component: SettingsMail
    },
    {
      path: '/settings/password',
      name: 'settings_password',
      component: SettingsPassword
    },
    {
      path: '/settings/twitter_auth',
      name: 'settings_twitter_auth',
      component: SettingsTwitterAuth
    },
    {
      path: '/about/terms',
      name: 'about_terms',
      component: Terms,
      meta: { isPublic: true }
    },
    {
      path: '/about/company',
      name: 'about_company',
      component: Company,
      meta: { isPublic: true }
    },
    {
      path: '/about/policies',
      name: 'about_policies',
      component: Policies,
      meta: { isPublic: true }
    },
    {
      path: '/about/share',
      name: 'about_share',
      component: Share,
      meta: { isPublic: true }
    }
  ]
})

const AppStore: Vuex.Store<any> = store
router.beforeEach((to, from, next) => {
  const ua = window.navigator.userAgent.toLowerCase()
  if (to.fullPath === '/' || ua.match(/(msie|MSIE)/) || ua.match(/(T|t)rident/)) {
    location.href = '/lp'
    return
  }
  if (to.matched.some(record => record.meta.isPublic)) {
    next()
  } else {
    const hasLoggedIn = document.cookie.includes('auth_status')
    if (!AppStore.state.auth.isLoggedIn && !hasLoggedIn) {
      AppStore.dispatch(
        'flash/setMessage',
        {
          message: 'ログインしてください',
          isAlert: true
        },
        {
          root: true
        }
      )
      next('/signin')
    }
    next()
  }
})

export default router
